"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRectangle = createRectangle;
var _konva = _interopRequireDefault(require("konva"));
var _ = _interopRequireDefault(require(".."));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function createRectangle(_ref) {
  var layer = _ref.layer,
    x = _ref.x,
    y = _ref.y,
    height = _ref.height,
    width = _ref.width,
    max = _ref.max,
    min = _ref.min,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    checkReverseRectangleX2 = _ref.checkReverseRectangleX2,
    name = _ref.name,
    _ref$onMouseMove = _ref.onMouseMove,
    onMouseMove = _ref$onMouseMove === void 0 ? null : _ref$onMouseMove,
    _ref$onMouseDown = _ref.onMouseDown,
    onMouseDown = _ref$onMouseDown === void 0 ? null : _ref$onMouseDown,
    _ref$onMouseUp = _ref.onMouseUp,
    onMouseUp = _ref$onMouseUp === void 0 ? null : _ref$onMouseUp,
    _ref$onMouseClick = _ref.onMouseClick,
    onMouseClick = _ref$onMouseClick === void 0 ? null : _ref$onMouseClick,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive;
  var stage = layer.getParent();
  var handleCallback = function handleCallback(func, event) {
    if (typeof func === "function") func(event);
  };
  var group = new _konva.default.Group({
    draggable: false,
    id: id,
    name: "Rectangle"
  });
  var rectMarker = new _konva.default.Rect({
    x: x,
    y: y,
    width: Math.abs(width),
    height: Math.abs(height),
    fill: "transparent",
    stroke: "white",
    strokeWidth: 3
  });

  // text label
  _.default.label({
    parent: group,
    text: "Max: ".concat(max, "\nMin: ").concat(min),
    position: {
      x: (x + checkReverseRectangleX2) / 2,
      y: y
    },
    offset: {
      x: 30,
      y: 45
    },
    rotation: -stage.rotation(),
    align: "center"
  });

  // name label
  _.default.label({
    parent: group,
    text: name,
    position: {
      x: x,
      y: y
    },
    offset: {
      x: -5,
      y: -5
    },
    rotation: -stage.rotation()
  });
  group.add(rectMarker);
  if (interactive) {
    group.on("mousemove", function (e) {
      handleCallback(onMouseMove, e);
    });
    group.on("mousedown", function (e) {
      handleCallback(onMouseDown, e);
    });
    group.on("mouseup", function (e) {
      handleCallback(onMouseUp, e);
    });
    group.on("click", function (e) {
      handleCallback(onMouseClick, e);
    });
  }
  layer.draw();
  layer.add(group);
}